import { render, staticRenderFns } from "./AssigneeTaskPage.vue?vue&type=template&id=d0627126&scoped=true&"
import script from "./AssigneeTaskPage.vue?vue&type=script&lang=js&"
export * from "./AssigneeTaskPage.vue?vue&type=script&lang=js&"
import style0 from "./AssigneeTaskPage.vue?vue&type=style&index=0&id=d0627126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0627126",
  null
  
)

export default component.exports